import { render, staticRenderFns } from "./WorkTaskMeasureTab.vue?vue&type=template&id=f2263a48"
import script from "./WorkTaskMeasureTab.vue?vue&type=script&lang=ts"
export * from "./WorkTaskMeasureTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports